import React, {useState} from 'react'
import {useHistory} from 'react-router-dom'

const CardMenu = (props: any) => {
  const [foco, setFoco] = useState(props.autoFocus ?? false)
  const history = useHistory()

  const navigation = () => {
    if (props?.to) history.push(props.to)
    if (props?.onClick) props.onClick()
  }

  return (
    <div className='w-layout-cell' id='card-menu-v2'>
      <button
        className={props.className || 'dashboard-card w-inline-block'}
        onMouseOver={props.activar}
        onMouseOut={props.desactivar}
        onClick={navigation}
        autoFocus={props.autoFocus}
        onFocus={() => setFoco(true)}
        onBlur={() => setFoco(false)}
        disabled={props.disabled}
        style={{opacity: props.disabled ? '0.5' : '1'}}
      >
        {(props.WhiteIcon || props.DarkIcon) && (
          <img
            src={props.activo || foco ? props.WhiteIcon : props.DarkIcon}
            loading='lazy'
            alt='Emitir Factura'
            className='card-icon '
            width='30px'
            height='30px'
          />
        )}
        <h2 className={(props.classNameH2 || 'dashboard-card-title') + ' l'}>{props.title}</h2>
        <p className={props.classNameDescrip || 'card-description' + ' m'}>{props.description}</p>
      </button>
    </div>
  )
}

export default CardMenu
